import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=4827cb11&shadow"
import script from "./badge.vue?vue&type=script&lang=js&shadow"
export * from "./badge.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports